import { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

import { SuspensedView } from '@components/SuspensedView'

const CustomerDisplayPage = lazy(() => import('@/pages/global/customer-display/CustomerDisplayPage'))
const QueuePresent = lazy(() => import('@modules/queue-presents/QueuePresents'))

const PublicRoutes = () => {
  return (
    <Routes>
      <Route
        path="/queue-present/:id"
        element={
          <SuspensedView>
            <QueuePresent />
          </SuspensedView>
        }
      />

      <Route
        path="/customer-display"
        element={
          <SuspensedView>
            <CustomerDisplayPage />
          </SuspensedView>
        }
      />
    </Routes>
  )
}

export { PublicRoutes }
